export const competenceMapSelector = state => state.competenceMap;
